import { format } from 'date-fns';
import dayjs, { Dayjs } from 'dayjs';
import { Calendar as CalendarIcon } from 'lucide-react';
import { memo } from 'react';
import { RefreshButton } from '../../../../../components';
import { Button } from '../../../../../components/ui/button';
import { Calendar } from '../../../../../components/ui/calendar';
import { Label } from '../../../../../components/ui/label';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../../../../components/ui/popover';
import { cn } from '../../../../../lib/utils';

interface StatisticsHeaderProps {
  filterDate: Dayjs;
  onFilterDateChange: (date: Dayjs) => void;
  onRefresh: () => void;
  isRefreshing: boolean;
}

export const StatisticsHeader = memo(function StatisticsHeader({
  filterDate,
  onFilterDateChange,
  onRefresh,
  isRefreshing,
}: StatisticsHeaderProps) {
  const today = dayjs();
  const minDate = today.subtract(40, 'days').toDate();
  const maxDate = today.add(1, 'day').toDate();

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-[hsl(210,50%,10%)]">
          Estatísticas
        </h1>
        <p className="text-[hsl(215,16%,47%)]">Análise de 40 dias retroativos</p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex items-center gap-2">
          <Label className="text-sm font-medium text-[hsl(210,50%,10%)] whitespace-nowrap">
            Data de Referência:
          </Label>
          <Popover>
            <PopoverTrigger asChild>
              <Button
                variant="outline"
                className={cn(
                  'w-40 justify-start text-left font-normal border-[hsl(214,32%,91%)] hover:bg-[hsl(210,40%,96%)]',
                  !filterDate && 'text-[hsl(215,16%,47%)]'
                )}
              >
                <CalendarIcon className="mr-2 h-4 w-4" />
                {filterDate ? (
                  format(filterDate.toDate(), 'yyyy-MM-dd')
                ) : (
                  <span>Selecionar data</span>
                )}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0 bg-white" align="start">
              <Calendar
                mode="single"
                selected={filterDate.toDate()}
                onSelect={(date) => {
                  if (date) {
                    onFilterDateChange(dayjs(date));
                  }
                }}
                disabled={(date) => date > maxDate || date < minDate}
                initialFocus
              />
            </PopoverContent>
          </Popover>
        </div>
        <RefreshButton onClick={onRefresh} loading={isRefreshing} />
      </div>
    </div>
  );
});
